import {
  Box,
  CircularProgress,
  Container,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import { useMemo, useState } from 'react'
import { HEADER_HEIGHT, Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { OptionUsagesTable } from './components/OptionUsagesTable'
import { PeriodSelector } from './components/PeriodSelector'
import { PeriodValue } from './periodOptions'
import { periodToDateRange } from './periodToDateRange'
import { useOptionUsages } from './useOptionUsages'

type Props = {
  date?: Date
}

export const OptionUsages = ({ date }: Props) => {
  const now = useMemo(() => (date ? date : new Date()), [date])

  const [selectedPeriod, setSelectedPeriod] =
    useState<PeriodValue>('last3months')

  const getOptionUsageParams =
    selectedPeriod === 'last3months'
      ? periodToDateRange({ period: 'last3months', now })
      : periodToDateRange({ period: selectedPeriod })

  const { isLoading, error, data } = useOptionUsages(getOptionUsageParams)
  const optionUsages = data?.optionUsages || []

  const handleApply = (period: PeriodValue) => {
    setSelectedPeriod(period)
  }

  return (
    <Box
      sx={{
        minHeight: `calc(100vh - var(--banner-height, 0px) - ${HEADER_HEIGHT}px)`,
      }}
    >
      <Header>
        <HeaderTitle title="AIラベル検査使用量" />
      </Header>
      <Container maxWidth="sm" sx={{ p: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Stack spacing={1}>
            <PeriodSelector
              initialPeriod={selectedPeriod}
              onApply={handleApply}
            />
            {isLoading && (
              <Stack alignItems="center">
                <CircularProgress />
              </Stack>
            )}
            {error && (
              <Stack justifyContent="center">
                <Typography color="error">
                  データの取得に失敗しました
                </Typography>
              </Stack>
            )}
            {optionUsages.length > 0 && (
              <OptionUsagesTable optionUsages={optionUsages} />
            )}
            {optionUsages.length === 0 && !isLoading && !error && (
              <Stack>
                <Typography>データがありません</Typography>
              </Stack>
            )}
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}
